<div class="fieldWrapper" fxLayout.lt-sm="column" fxLayout.gt-xs="row" fxLayoutAlign="start center" [formGroup]="theForm">
    <label class="label" fxFlex="1 1 60%" *ngIf="showLabel">
        <span matTooltip="{{ metaData?.description }}">{{ metaData?.friendlyName }}</span>
    </label>
    <mat-form-field [appearance]="isEmbedded ? 'standard' : 'outline'" class="select" [class.showLabel]="showLabel">
        <mat-label>{{ metaData?.friendlyName }}</mat-label>
        <mat-select [formControl]="formControl">
            <mat-option *ngIf="selectLabel" [value]="selectLabel.labelValue" disabled>{{ selectLabel.labelKey }}</mat-option>
            <mat-option *ngFor="let option of selectOptions" [value]="option.value">{{ option.key }}</mat-option>
        </mat-select>
    </mat-form-field>
    <div *ngIf="formControl.disabled && !isLoading && enableRetry">
        <mat-button-toggle (click)="getValueEmitter.emit()">Retry</mat-button-toggle>
    </div>
    <clare-spinner *ngIf="isLoading" text="Loading Value" position="absolute" overlay="true"></clare-spinner>
</div>
